module.exports = __webpack_public_path__ + "img/SwapTokenError.cf1c2e53.svg";